import { TicketSeverity, TicketSource } from '@kfolks/types'
import { z } from 'zod'

export const ticketUpsertSchema = z.object({
	source: z.nativeEnum(TicketSource),
	dedupeKey: z.string().min(1),
	severity: z.nativeEnum(TicketSeverity),
	title: z.string().min(1),
	description: z.string().min(1),
	metadata: z.record(z.string(), z.unknown()).optional(),
})

export const ticketCloseMissingSchema = z.object({
	source: z.nativeEnum(TicketSource),
	dedupeKeys: z.array(z.string().min(1)).min(1),
})

export type TicketUpsertInput = z.infer<typeof ticketUpsertSchema>
export type TicketCloseMissingInput = z.infer<typeof ticketCloseMissingSchema>
